'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonGroup = require('./ButtonGroup');

Object.defineProperty(exports, 'ButtonGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonGroup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/buttonGroup/index.js
// module id = 551
// module chunks = 0